import pickup from "assets/images/pickUp.svg";
import drop from "assets/images/drop.svg";
import clock from "assets/images/clock.svg";
import liveIcon from "assets/images/liveIcon.svg";
import packageTime from "assets/images/packageTime.svg";

export const oneWayData = (trip) => [
  {
    id: 1,
    placeholder: "Pickup address",
    required: true,
    type: "text",
    name: "pickup",
    autoComplete: true,
    image: pickup,
    icon: liveIcon,
    border: true,
    disabled:trip ? true : false
  },
  {
    id: 2,
    placeholder: "Drop address",
    required: true,
    type: "text",
    name: "drop",
    autoComplete: true,
    image: drop,
    disabled:trip ? true : false
  },
  {
    id: 3,
    placeholder: "Today",
    required: true,
    type: "date",
    name: "date",
    image: clock,
    disabled:trip ? true : false
  },
];
export const rentalData = (optionData,trip) => [
  {
    id: 1,
    placeholder: "Pickup address",
    required: true,
    type: "text",
    name: "pickup",
    autoComplete: true,
    image: pickup,
    icon: liveIcon,
    disabled:trip ? true : false
  },
  {
    id: 3,
    placeholder: "Package",
    required: true,
    type: "options",
    name: "package",
    options:optionData,
    image: packageTime,
    disabled:trip ? true : false
  },
  {
    id: 3,
    placeholder: "Today",
    required: true,
    type: "date",
    name: "date",
    image: clock,
    disabled:trip ? true : false
  },
];
export const airportData = (airportFormatData,trip) =>[ 
  {
    id: 1,
    placeholder: "Pickup address",
    required: true,
    type: "text",
    name: "pickup",
    autoComplete: true,
    image: pickup,
    icon: liveIcon,
    border: true,
    disabled:trip ? true : false
  },
  {
    id: 2,
    placeholder: "Airport Address",
    required: true,
    singleAutoComplete:true,
    name: "drop",
    image: drop,
    airportFormatData:airportFormatData,
    disabled:trip ? true : false
  },
  {
    id: 3,
    placeholder: "Today",
    required: true,
    type: "date",
    name: "date",
    image: clock,
    disabled:trip ? true : false
  },
];

export const outStationData  = (trip) => [
  {
    id: 1,
    placeholder: "Pickup address",
    required: true,
    type: "text",
    name: "pickup",
    autoComplete: true,
    image: pickup,
    icon: liveIcon,
    border: true,
    disabled:trip ? true : false
  },
  {
    id: 2,
    placeholder: "Drop address",
    required: true,
    type: "text",
    name: "drop",
    autoComplete: true,
    image: drop,
    disabled:trip ? true : false
  },
  { 
    id: 3,
    placeholder: "Start Date",
    required: true,
    type: "date",
    name: "date",
    image: clock,
    disabled:trip ? true : false
  },
  { 
    id: 4,
    placeholder: "End Date",
    required: true,
    type: "date",
    name: "endDate",
    image: clock,
    disabled:trip ? true : false
  }
 
]
